<template>
  <div>
    <el-dialog
      :visible.sync="recordDialogVisible"
      title="产品基础属性查看"
      width="70%"
      @cancel="updateVal"
      @close="updateVal"
    >
      <div>
        <el-table border :data="dialogData" height="210">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            show-overflow-tooltip
            v-for="item in monthTable"
            :key="item.prop"
            :align="item.align"
          >
            <template slot-scope="scope">
              <template v-if="item.label === '图片'">
                <!-- <template v-if="showDetailBtn(scope.row)"> -->
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="showDialog(scope.row, 0)"
                    >查看</el-link
                  >
                </template>
              <!-- </template> -->
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    // dialogData: Array
  },
  computed: {
    title() {
      return this.skuCode ? '修改SKU' : '新增SKU';
    },
    // 是否翻拍
    isRemake() {
      return +this.spuType === 2;
    }
  },
  data() {
    return {
      recordDialogVisible: false,
      dialogData: [
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
        {categoryName:'Rx-234',categoryTotal:'Rx-234',priceN1:'Rx-234',priceN2:'Rx-234',priceN3:'Rx-234',priceN4:'Rx-234',priceN5:'Rx-234'},
      ],
      monthTable: [
        { label: '图片', prop: 'categoryName', width: '150px', sortable: false, span: false, fixed: 'left', align:'left' },
        { label: '产品编码', prop: 'categoryTotal', width: '120px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
        { label: '产品名称', prop: 'priceN1', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        { label: '风格', prop: 'priceN2', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        { label: '材质', prop: 'priceN3', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        { label: '颜色', prop: 'priceN4', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        { label: '销量', prop: 'priceN5', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        { label: '全网销量', prop: 'priceN5', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
      ]
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.recordDialogVisible = this.visible
    },
    showDialog(row) {
    },
    updateVal() {
      console.log(999);
      setTimeout(_=>{
        this.$emit('dialog', false)
      },200)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .backPlay{
    &:hover{
      opacity: 1
    }
  }
  .el-button--whiteBackground {
      opacity: .5;
      padding: 7px
      position: absolute;
      padding: 5px 7px
      right: 10px
      bottom: 10px
      color: #FFF;
      background-color: #0BB78E;
      border-color: #0BB78E;
  }
</style>>

